import { Tabs, TabContent } from '../../../shared/ui';
import { useSelector, useDispatch } from 'react-redux';
import { callModel } from '../../call/model';

import { cn } from '@distribute/frontend/utils';

import { Calls } from './Calls';

import { EditCallModal } from './EditCallModal';
import { DeleteCallModal } from './DeleteCallModal';
import { TogglePrivacyCallModal } from './TogglePrivacyCallModal';

import { CALL_TABS, CallTab } from '../../../entities/call-recordings';

import { CallsFilters } from './CallsFilters';

export const CallTabs = () => {
  const dispatch = useDispatch();

  const hasOnlyMyCalls = useSelector(callModel.selectors.selectHasOnlyMyCalls);

  const callListOptions = useSelector(
    callModel.selectors.selectCallListOptions
  );
  const callListMeta = useSelector(callModel.selectors.selectCallListMeta);

  const isCallListLoading = useSelector(
    callModel.selectors.selectIsCallListLoading
  );

  const editingCallItem = useSelector(
    callModel.selectors.selectEditingCallItem
  );
  const deletingCallItem = useSelector(
    callModel.selectors.selectDeletingCallItem
  );
  const togglingCallItem = useSelector(
    callModel.selectors.selectTogglingCallItem
  );

  const selectedTab =
    callListOptions.type === 'team' ? CALL_TABS[1] : CALL_TABS[0];

  const handleTabChange = (tab: TabContent) => {
    dispatch(callModel.actions.resetOptions());
    dispatch(
      callModel.actions.setListOptions({
        type: tab.name === CallTab.TEAM_CALLS ? 'team' : 'personal',
      })
    );
    dispatch(callModel.actions.loadCalls());
  };

  return (
    <div
      className={cn('flex flex-col flex-grow-1 gap-y-6', {
        'pb-6': callListMeta.totalItems > 0 && !isCallListLoading,
      })}
    >
      <div
        className={cn(
          'flex flex-nowrap items-end gap-4 md:justify-end md:flex-col min-h-10',
          { hidden: hasOnlyMyCalls }
        )}
      >
        <Tabs
          tabsOnly
          tabs={CALL_TABS}
          selectedTab={selectedTab}
          onSelectTab={handleTabChange}
          className={cn('!mb-0')}
        />
        <CallsFilters />
      </div>
      {hasOnlyMyCalls && <CallsFilters />}
      <Calls />
      {editingCallItem && <EditCallModal />}
      {deletingCallItem && <DeleteCallModal isFromList />}
      {togglingCallItem && <TogglePrivacyCallModal isFromList />}
    </div>
  );
};
